import React from "react";

// Custom Components
import Sidebar from "../../components/Common/Sidebar";
import Header from "../../components/Common/Header";

// Context
import { useContentScale } from "../../context/contentScale/ContentScaleContext";

// CSS
import "./style.css";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { scale } = useContentScale();

  return (
    <>
      <Header />
      <div id="wrapper">
        <Sidebar />
        {/* zoom (not transform: scale) so the content reflows at its new
            size instead of just visually stretching/shrinking in place --
            only this pane scales, Header and Sidebar are unaffected. */}
        <div
          id="content-wrapper"
          className="d-flex flex-column"
          style={{ zoom: `${scale}%` }}
        >
          <div className="content">
            <div className="page-wrapper dash-wrapper">
              <div className="page-content dashboard-cont">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainLayout;
